let pageLoadId = 0;

export const getPageLoadId = (): number => pageLoadId;
export const incrementPageLoadId = (): number => {
  pageLoadId = pageLoadId + 1;

  return pageLoadId;
};

export const debugResetPageLoadId = (): void => {
  pageLoadId = 0;
};
